import React, {Fragment} from 'react'

import {
  EuiBreadcrumbs,
  EuiSpacer
} from '@elastic/eui'


export default function ManualBreadcrumbs() {

  const breadcrumbs = [
    {
      text: 'Übersicht',
      href: '/de/Aussenkameras/IN-9408_WQHD/',
    },
    {
      text: 'Spezifikationen',
      href: '/de/Aussenkameras/IN-9408_WQHD/Technische_Spezifikationen/',
    },
    {
      text: 'Features',
      href: '/de/Aussenkameras/IN-9408_WQHD/Produkt_Features/',
    },
    {
      text: 'Installation',
      href: '/de/Aussenkameras/IN-9408_WQHD/Schnell_Installation/',
    },
    {
      text: 'Objektivjustage',
      href: '/de/Aussenkameras/IN-9408_WQHD/Objektivjustage/',
    },
    {
      text: 'Handbuch',
      href: '/de/Aussenkameras/IN-9408_WQHD/Handbuch/',
    },
    {
      text: '◄ Außenkameras',
      href: '/de/Aussenkameras/',
    }
  ];

  return (
    <Fragment>
      <EuiBreadcrumbs
        truncate={true}
        breadcrumbs={breadcrumbs}
        max={10}
        aria-label="INSTAR IN-9408 2k+ WQHD Online Benutzerhandbuch Kapitel"
      />
      <EuiSpacer />
    </Fragment>
  );
}